import { GOOGLE_MAPS_API } from "../../environment_variable";
import AssetManagement from "../../components/dashboard/AssetManagement-v1.1";

export default function Asset() {
  
  return (
    <main id="page-content" className="flex max-w-full flex-auto flex-col">
      <AssetManagement />
    </main>
  )
}